// action types
import { createRequestTypes } from "../../utils";

export const FETCH_FUN_FACT = createRequestTypes("FETCH_FUN_FACT");

export const fetchFunFactRequest = () =>
    ({ type: FETCH_FUN_FACT.REQUEST });

export const fetchFunFactSuccess = (funFact) =>
    ({ type: FETCH_FUN_FACT.SUCCESS, payload: { funFact } });

export const fetchFunFactFailure = (error) =>
    ({ type: FETCH_FUN_FACT.FAILURE, payload: { error } });
